import React, { CSSProperties, ReactNode } from 'react';
import { Card } from 'antd';

export type AnalyticsChartCardVariant = 'standard' | 'flush';

export type AnalyticsChartCardProps = {
	title: ReactNode;
	extra?: ReactNode;
	children: ReactNode;
	/**
	 * 'standard' applies the body padding and break-inside-avoid print classes used by the
	 * metric line and spend bar charts. 'flush' uses Card defaults (no body padding override)
	 * with the simpler print classes used by the WO Performance card.
	 */
	variant?: AnalyticsChartCardVariant;
	className?: string;
	bodyStyle?: CSSProperties;
};

const VARIANT_CLASS_NAMES: Record<AnalyticsChartCardVariant, string> = {
	standard:
		'print:!h-auto print:!min-h-0 print:!break-inside-avoid ' +
		'print:[&_.ant-card-body]:!break-inside-avoid ' +
		'print:[&_.ant-card-body]:!px-2 ' +
		'print:[&_.ant-card-body]:!pb-3 ' +
		'print:[&_.ant-card-body]:!pt-4',
	flush: 'print:!h-auto print:!min-h-0',
};

const STANDARD_BODY_STYLE: CSSProperties = { padding: '57px 36px 24px 16px' };

const AnalyticsChartCard = ({
	title,
	extra,
	children,
	variant = 'standard',
	className,
	bodyStyle,
}: AnalyticsChartCardProps) => {
	const resolvedClassName = className !== undefined ? className : VARIANT_CLASS_NAMES[variant];
	const resolvedBodyStyle =
		bodyStyle !== undefined ? bodyStyle : variant === 'standard' ? STANDARD_BODY_STYLE : undefined;
	return (
		<Card className={resolvedClassName} bodyStyle={resolvedBodyStyle} title={title} extra={extra}>
			{children}
		</Card>
	);
};

export default AnalyticsChartCard;
